import { SelectInput } from "./SelectInput";
import type { SelectInputProps } from "./SelectInput";
import { Label } from "./Label";
import { FieldError } from "./FieldError";
import { twMerge } from "tailwind-merge";

interface SelectFieldProps extends SelectInputProps {
  label?: string;
  optional?: boolean;
  errorMessage?: string;
}

export function SelectField({
  label,
  optional,
  errorMessage,
  className,
  name,
  ...props
}: SelectFieldProps) {
  const hasError = Boolean(errorMessage);

  return (
    <div className={twMerge("flex flex-col gap-2", className)}>
      {label && (
        <Label htmlFor={name} optional={optional}>
          {label}
        </Label>
      )}

      <SelectInput name={name} error={hasError} {...props} />

      {hasError && <FieldError message={errorMessage!} />}
    </div>
  );
}
